module.exports = __webpack_public_path__ + "static/media/8OLA16.42793b3c.jpg";